var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","rounded":"","v-bind":_vm.$attrs},on:{"click":function($event){$event.preventDefault();return _vm.$emit('updated')}}},[_c('v-icon',[_vm._v("\n    fal fa-fw fa-redo\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }